import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { StatusIndications } from '../common';

export interface RichTextInputAreaUniDriver extends BaseUniDriver {
  isDisabled: () => Promise<boolean>;
  getContent: () => Promise<string>;
  getPlaceholder: () => Promise<string | null>;
  enterText: (value: string) => Promise<void>;

  /** Check if rich text input area has focus. */
  hasFocus: () => Promise<boolean>;
  /** Focus rich text input area element. */
  focus: () => Promise<void>;
  /** Blur rich text input area element. */
  blur: () => Promise<void>;

  // Status
  hasStatus: (status: StatusIndications) => Promise<boolean>;
  getStatusMessage: () => Promise<string | null>;
}
